export enum RETAILERS {
  DEFAULT = 'default', // White mark design
  PONA = 'pona', // Tesco
  CETOINE = 'cetoine', // Carrefour
  SHANE = 'shane', // Morissons
  DRACO = 'draco', // intermaché
  CHONDRUS = 'chondrus', // Leclerc
  NIX = 'nix', // Picard
  LYNX = 'lynx', // Hy-Vee
  SCORPIO = 'scorpio', // FairPrice
  LACERTA = 'lacerta', // ASDA
  HYDRA = 'hydra', // KwikTrip
  CYGNUS = 'cygnus', // Wakefern
  BOREAS = 'boreas', // Boots
  STELLAR = 'stellar', // Starter Bros
}
